import React, { useEffect, useState } from 'react'

import {Box} from '@mui/material'
import useStyles from '../../../styles/global-mui.js';

import LivePopupCreator from './popup/LivePopupCreator.js';
import { useDispatch, useSelector } from 'react-redux';
import { createLiveByCompetitionDetails, updateLive } from '../../../actions/lives.js';
import { getUserProvider  } from '../../../actions/auth.js';
import { getLiveInfo} from '../../../api/index.js';
import { ReactComponent as MySvgIcon } from '../../../images/picto/standard/creer_un_direct.svg';
import { ReactComponent as MySvgIconHover } from '../../../images/picto/blue/creer_un_direct_bleu.svg';
import DsasButton from '../../../v1/components/DsasButton/DsasButton.js';


const CreateCompetitionLiveCustom = ({currentId, setCurrentId}) => {

    const classes = useStyles();

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

    const currentUser = useSelector(state => state.authentication.currentUser);
    const provider = currentUser?.groups; // ou currentUser?.groups si c’est ça le "provider"
    
      const buildInitialLiveData = () => ({
        name : '',
        dateTime : new Date(),
        provider: provider ?? null, // fallback explicite si jamais le user n'est pas encore prêt
        userNames : [],
        competitionDetails : [],

        matchs : [],
        matchsDetails : [],
        competitionOrder : []
      });
    
      const [state, setState] = useState(buildInitialLiveData);
    
    
       const handleClickOpen = () => {
        if (!provider) {
            console.warn('Provider non défini, popup non ouvert.');
            return;
          }
          setState(buildInitialLiveData());
          setOpen(true);
        };
        

    const handleClose = () => setOpen(false);

    const handleConfirm = () => {
      if(!currentId)
        dispatch(createLiveByCompetitionDetails(state))
      else
        dispatch(updateLive(currentId, state))

      handleClose()

      setState(buildInitialLiveData())
    }

    const handleCancel = () => {
      setState(buildInitialLiveData())
      setCurrentId(null)
    }



    useEffect(() => {
      if(!currentId)
        return

      const fetchData = async () => {
        try {
          const response = await getLiveInfo(currentId);
          // Effectuer la tâche une fois la réponse reçue

          const {name, dateTime, provider, matchs, matchsDetails, competitionOrder, actualites} = response.data
          setState({
            name, dateTime, provider, matchs, actualites, matchsDetails, competitionOrder, competitionDetails : [], isEditMode : true
          })
          setOpen(true)

        } catch (error) {
          console.error(error);
        }
      };
  
      fetchData();
    }, [currentId]); // Exécuter useEffect à chaque fois que idLive change

    useEffect(() => {
      
    }, [open]);


    const RenderIcon = (props) => <MySvgIcon key={props.key} />;
    const RenderIconHover = (props) => <MySvgIconHover key={props.key} />;


    return (
      <Box className='centered-wrapper'>
        <DsasButton 
          label='Créer un direct de compétitions' 
          variant='secondary' 
          customIcon={RenderIcon}
          customIconHover={RenderIconHover}
          customCss={{
            display: 'flex',
            alignItems: 'center'}}
          onClick={handleClickOpen} ></DsasButton>
  
        {/* Rendu hors du Box cliquable */}
        <LivePopupCreator
          open={open}
          setOpen={setOpen}
          handleConfirm={handleConfirm}
          handleInit={handleCancel}
          state={state}
          setState={setState}
          initialState={buildInitialLiveData()}
        />
      </Box>
    );

}

export default CreateCompetitionLiveCustom